import React, { useCallback, useState,useEffect } from 'react';
import { useFormContext } from './formContext';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ENDPOINTS } from '@/config/endpoints';
import axios from 'axios';
import { useRouter } from 'next/router';
import { pushCleverTapEvent } from '../pushCleverTapEvent';

yup.addMethod(yup.string, 'restrictedEmail', function (message) {
  return this.test('restrictedEmail', message, function (value) {
    if (!value) return true; // If the value is empty, let other validations handle it

    const restrictedDomains = ['gmail.com', 'yahoo.com'];
    const domain = value.split('@')[1];

    return !restrictedDomains.includes(domain?.toLowerCase());
  });
});
const schema = () => {
  return yup.object({
    Name: yup.string().required('This field is required.'),
    Email: yup.string().required('This field is required.').email('Email is not valid').restrictedEmail('Kindly provide the official email associated with the company.'),
    Companyname: yup.string().required('This field is required.'),
  });
};


const ContactFormStep2 = ({ showPrevStep, formType,blogPostID,pageTitle }) => {
  const router = useRouter();

  const validationSchema = schema();
  const { state, dispatch } = useFormContext();
  const timeFrame = [
    { id: 'immediately', title:'Immediately' },
    { id: 'in 2 weeks', title: 'In 2 Weeks' },
  ]
  const [ThankyouRes, setThankyouRes] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [errMSG, setErrMSG] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema)
  });
 const pillerID = ENDPOINTS.WORDPRES_DOWNLOAD_PDF;
 const matchedItem = pillerID.find((item) => item.id === blogPostID);

  const handleCaptchaSubmit = useCallback((values) => {

    if (!executeRecaptcha) {
      return false;
    }
    executeRecaptcha().then((gReCaptchaToken) => {
      onFormSubmit(values, gReCaptchaToken);
    });
  },
    [executeRecaptcha]
  );

  const getCleverTapEvent = (path, body) => {
     if (router.asPath === '/') {
      return { event: "Submit_Finance", data: { PageName: 'HomePage', ...body, 'userProperties': 'financing_intent_status'} };
     } else if (path.includes('/blogs')) {
      return { event: "Blog_Form_Submit", data: { PageName: 'Blog_Page', ...body } };
    } else if (path.includes('/hsn-code')) {
      return { event: "HSN_Form_Submit", data: { PageName: 'HSN_Form_Submit', ...body,'userProperties': 'signup_source_page'} };
    } else if (path.includes('/contact-us')) {
      return { event: "Contact_us_Form_Submit", data: { PageName: 'Contact_Us_Page', ...body } };
    } else if (path.includes('/credlix-finsight')) {
      return { event: "Finsights_Form_Submit", data: { PageName: 'Finsights', ...body } };
    } else if (path.includes('/export-factoring/purchase-order-financing')) {
      return { event: "PO_Finance_Form_Submitted", data: { PageName: 'PO_Finance', ...body } };
    } else if (path.includes('/export-factoring/invoice-discounting-platform')) {
      return { event: "SID_Form_Submitted", data: { PageName: 'Sales_Bill_Discounting', ...body } };
    } else if (path.includes('/enterprise/vendor-financing-india')) {
      return { event: "VF_OTP_Submitted", data: { PageName: 'Vendor_Finance', ...body } };
    } else if (path.includes('/enterprise/channel-financing-india')) {
      return { event: "CF_Form_Submitted", data: { PageName: 'Channel_Finance' } };
    } else if (path.includes('/enterprise/early-payment-discount')) {
      return { event: "EP_Form_Submitted", data: { PageName: 'Early_Payment', ...body } };
    } else if (path.includes('/import-factoring')) {
      return { event: "import_factoring", data: { PageName: 'import_factoring', ...body } };
    }
    return null; // If no match
  };

  // handle form submit 
  async function onFormSubmit(values, gReCaptchaToken) {
    const body = {
      "formType": formType,
      "name": values.Name,
      "email": values.Email,
      "phoneNumber": state.formData.phone,
      "company": values.Companyname,
      "businessType": state.formData.exportValue,
      "turnover": state.formData.financeAmt,
      "timeLineForFinance": values.timeLineForFinance,
      "sourceUrl": window.location.href,
      "website": state.formData.website
    }

    let config = {
      method: 'post',
      url: ENDPOINTS.CONTACT_US_V1,
      headers: {
        'Content-Type': 'application/json',
        'g-recaptcha-response': gReCaptchaToken
      },
      data: body,
    };


    try {
      const response = await axios(config);
      if (response.status == 200) {
        // setSubmitDisabled(true);
        setThankyouRes(true);
        gtag('event',  router.asPath.includes(pageTitle) ? 'import_factoring' : 'submitFinance', {
          'event_category': 'Submit button',
          'event_label': 'Submit button'
        });
        const cleverTapPayload = getCleverTapEvent(router.asPath, body);
        if (cleverTapPayload) {
          pushCleverTapEvent(cleverTapPayload.event, cleverTapPayload.data);
        }
        if (matchedItem && matchedItem.pdf_link) {
          const pdfUrl = matchedItem.pdf_link;
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.download = matchedItem.filename; 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          gtag('event', 'getPillarCluster', {
            'event_category': 'Submit button',
            'event_label': 'Submit button'
          });
        }
        setTimeout(() => {
          setThankyouRes(false);
          if(!matchedItem){
            router.push('/thankyou-response')
          }
          window.dataLayer.push({
            event: 'DomesticFormconversion',
            'Conversion_ID': '16468312892',
            'Conversion_labels': '-6pqCKanyt0ZELyG2qw9'
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }, 5000);
       }
        reset();

        state.formData == {}
    } catch (err) {
      setErrMSG(true);
    }

  }

  const handlePrev = () => {
    showPrevStep(true)
    if (state.step == 2) {
      showPrevStep(true)
    }
    // Dispatch action to go back to the previous step
    dispatch({ type: 'PREV_STEP' });
  };

  return (

    <div className={`${router.asPath.includes(pageTitle) ? 'sm:w-[375px] py-1 sm:px-2 px-2 mb-2' : 'py-4 pb-6 sm:px-2 px-5'} bg-white rounded-[15px] lg:w-full lg:max-w-[450px] md:max-w-[400px] mx-auto md:relative md:m-auto md:mb-[20px] min-h-[500px]`}>
      <div>
        <button type='button' onClick={handlePrev} className='flex items-center text-sm text-secondary font-medium mb-3'>
          <span className='mr-1'>
            <svg xmlns="https://www.w3.org/2000/svg"
              viewBox="0 0 24 24" width="24" height="24"
              fill="rgba(0,0,0,1)"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"></path></svg>
          </span>
          Back
        </button>
      </div>
      <form onSubmit={handleSubmit(handleCaptchaSubmit)} className='border border-bordercolor rounded-md p-2 sm:p-1 min-h-[400px] relative'>
        {/* <form onSubmit={handleSubmit(onFormSubmit)} className='border border-bordercolor rounded-md p-3 min-h-[400px] relative'> */}
        <div className="mt-2">
          <div>
            <label htmlFor="Name" className="text-sm font-medium text-secondary">
            Full Name*
            </label>
            <input
              type="text"
              {...register("Name")}
              name="Name"
              id="Name"
              autoComplete="name"
              aria-required="true"
              className="block w-full rounded-md border border-bordercolor mt-1 h-6 py-1.5 pl-2 text-base md:text-sm text-secondary  focus:border-[#555] focus:ring-[#555] focus:outline-none"
              placeholder="Enter Your Name"
            />
          </div>
          <p className='text-progressColor4 text-xs mt-[3px]'>{errors.Name?.message}</p>
        </div>
        <div className="mt-3">
          <label htmlFor="Companyname" className="text-sm font-medium text-secondary">
          Company*
          </label>
          <div >
            <input
              type="text"
              {...register("Companyname")}
              name="Companyname"
              id="Companyname"
              autoComplete="organization"
              aria-required="true"
              className="block w-full rounded-md border border-bordercolor mt-1 h-6 py-1.5 pl-2 text-base md:text-sm text-secondary  focus:border-[#555] focus:ring-[#555] focus:outline-none"
              placeholder="Enter your Company Name"
            />
          </div>
          <p className='text-progressColor4 text-xs mt-[3px]'>{errors.Companyname?.message}</p>
        </div>
        <div className="mt-3">
          <label htmlFor="Email" className="text-sm font-medium text-secondary">
          Email Id*
          </label>
          <div >
            <input
              type="email"
              name="Email"
              {...register("Email")}
              id="Email"
              autoComplete="email"
              aria-required="true"
              className="block w-full rounded-md border border-bordercolor mt-1 h-6 py-1.5 pl-2 text-base md:text-sm text-secondary  focus:border-[#555] focus:ring-[#555] focus:outline-none"
              placeholder="Enter your Email ID"
            />
          </div>
          <p className='text-progressColor4 text-xs mt-[3px]'>{errors.Email?.message}</p>
        </div>
        <div className='mt-3 pl-[5px]'>
          <label className="text-sm font-medium text-secondary">When do you need finance?</label>
          <fieldset className="mt-1">
            <div className="space-x-10 flex items-center sm:flex sm:items-center sm:space-x-3 sm:space-y-0">
              {timeFrame.map((timeFrame) => (
                <div key={timeFrame.id} className="flex items-center">
                  <input
                    id={timeFrame.id}
                    name="timeLineForFinance"
                    type="radio"
                    {...register("timeLineForFinance")}
                    value={timeFrame.title}
                    defaultChecked={timeFrame.id === 'immediately'}
                    className="h-3 w-3 cursor-pointer border-gray-300 text-indigo-600 focus:ring-bordercolor"
                  />
                  <label htmlFor={timeFrame.id} className="ml-3 cursor-pointer block text-sm font-medium leading-6 text-gray-900 select-none">
                    {timeFrame.title}
                  </label>
                </div>
              ))}
            </div>
          </fieldset>
        </div>
        <div className='mt-6'>
          <button type='submit' 
          // onClick={() => {
          //   gtag('event', 'submit', {
          //     'event_category': '2 steps contact form',
          //     'event_label': 'Footer Form'
          //   });}}
            className='py-1 px-3 rounded-md w-full text-white text-sm mx-auto bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]'>
            Submit
          </button>
        </div>
      </form>
      {errMSG ?
        <div className='text-[red] text-center' >
          <p className='text-sm font-medium mt-3'>
          There is some server response error.
          </p>
        </div>
        : null}
      {ThankyouRes ?

        <div className='text-green text-center' >
          <p className='text-sm font-medium mt-3'>
              Successfull Submission : Thank you for your interest.

          </p>
        </div>

        : null}
    </div>

  )
}

export default ContactFormStep2;